import './setupHttpClient';
import './setupI18n';
import './setupObservability';

import { Suspense } from 'react';
import { Spin } from 'antd';
import { ErrorBoundaryProvider } from './ErrorBoundaryProvider';
import { QueryProvider } from './QueryProvider';
import { ReduxProvider } from './ReduxProvider';
import { GlobalStateProvider } from './GlobalStateProvider';
import { PermissionProvider } from 'shared/lib/permissions';

const I18nFallback = () => (
  <div
    style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh',
      fontSize: 14,
    }}
  >
    <Spin size="large" />
  </div>
);

export const AppProviders = ({ children }) => (
  <Suspense fallback={<I18nFallback />}>
    <ErrorBoundaryProvider>
      <QueryProvider>
        <ReduxProvider>
          <GlobalStateProvider>
            <PermissionProvider>{children}</PermissionProvider>
          </GlobalStateProvider>
        </ReduxProvider>
      </QueryProvider>
    </ErrorBoundaryProvider>
  </Suspense>
);
